import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Quote } from '../models/quote';

@Injectable({
  providedIn: 'root',
})
export class QuoteService {
  private quoteSource = new BehaviorSubject<Quote | null>(null);
  currentQuote = this.quoteSource.asObservable();

  constructor() {}

  updateQuote(quote: Quote) {
    this.quoteSource.next(quote);
  }
}
